<template>
  <div class="container">
  <div class="quyu">
    <div class="home-banner">
        <img class="banner-bg" src="@/assets/生成系统.png" alt="">
        <div class="textBox typeArea">
        <p class="centerBanner animated zoomIn">基于考试大数据的综合测评报告生成系统</p>
        </div>
    </div>
    <div class="project">
      <div class="proj-box">
        <div class="proj-cont">
          <div style="padding-bottom: 45px;"></div>
          <div class="common-title">
            场景说明 
          </div>
          <div class="proj-text">
            <p>业内排头的职业资质考试平台公司，为国内外数百委托机构提供全国性的考试服务。业务中需要针对考试、考生和试题为委托机构生成测评分析报告。</p>
          </div>
          <div style="padding-bottom: 55px;"></div>
        </div>
      </div>
      <div class="proj-box" style="background:#F3F4F7">
        <div class="proj-cont">
          <div style="padding-bottom: 80px;"></div>
          <div class="common-title">
            业务需求点 
          </div>
          <div style="padding-bottom: 80px;"></div>
          <div class="proj-t">
            <div class="proj-sanjiao">
              <img src="@/assets/sanjiao.png" alt="">
            </div>
            <div class="proj-text" style="font-size: 14px;">
              建立横跨各个委托机构和考试门类的通用性考试诊断报告生成系统
            </div>
          </div>
          <div class="proj-t">
            <div class="proj-sanjiao">
              <img src="@/assets/sanjiao.png" alt="">
            </div>
            <div class="proj-text" style="font-size: 14px;">
              报告的终端用户包括本公司的管理和项目经理人员，以及委托机构的对口管理人员
            </div>
          </div>
          <div class="proj-t">
            <div class="proj-sanjiao">
              <img src="@/assets/sanjiao.png" alt="">
            </div>
            <div class="proj-text" style="font-size: 14px;">
              报告内容分主题分层次，并须模块化，从而可以根据不同委托机构的个性化需要进行拆解和聚合
            </div>
          </div>
          <div class="proj-t">
            <div class="proj-sanjiao">
              <img src="@/assets/sanjiao.png" alt="">
            </div>
            <div class="proj-text" style="font-size: 14px;">
              对网页版报告，文字可由用户自主编辑和修改，并保存为报告模板；网页版报告可一键转化为PDF和WORD版本
            </div>
          </div>
          <div style="padding-bottom: 50px;"></div>
        </div>
      </div>
    </div>
    <div class="proj-box">
      <div class="proj-cont">
        <div style="padding-bottom: 60px;"></div>
        <div class="common-title">
          解决方案 
        </div>
        <div class="proj-text" >
          <p style="text-indent: 0;">部盾的诊断报告生成系统涵盖了项目需求中的所有功能</p>
          <p style="text-indent: 0;"></p>配合特定场景，建立了定制化的数据上传、数据自检和入库功能；标准化的数据与报告生成系统直接对接，一键生成网页报告</p>
          <p style="text-indent: 0;">配合特定场景，建立了客户指定的用户权限管理结构</p>
        </div>
        <div style="clear: both;"></div>
      </div>
    </div>
    <div class="proj-box">
      <div class="proj-cont">
        <div style="padding-bottom: 40px;"></div>
        <div class="proj-fangan">
          <img src="@/assets/图层11.png" style="width: 1200px;height;693px;" alt="">
        </div>
        <div style="padding-bottom: 40px;"></div>
      </div>
    </div>
  </div>  
</div>
</template>

<script>
export default {
  name: "kaoshi",
  data() {
    return {
    };
  },
  methods: {
      
  },
  mounted() {

  },
}
</script>

<style scoped>
   
</style>